import { Form, Select } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import EndPoints from "./EndPoints";
import toast from "react-hot-toast";
import {
  AppDispatch,
  getSystemApiModuleList,
  getSystemApiModuleListRequest,
  getSystemUiModuleListRequest,
  updateSystemUiModuleComponent,
  updateSystemUiModuleComponentClear,
  updateSystemUiModuleComponentRequest,
} from "../../../../redux";

// Define the types for props
interface EndPointFormProps {
  getId: {
    id: string;
    name: string;
  };
  linkType: string;
  setLoading: (loading: boolean) => void;
  actionItem: any;
  close: () => void;
  actionType: string;
}

const EndPointForm: React.FC<EndPointFormProps> = ({
  getId,
  linkType,
  setLoading,
  actionItem,
  close,
  actionType,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();

  const { result: apiList } = useSelector(getSystemApiModuleList);

  const {
    result: updateStatus,
    loading: updateLoading,
    error: updateError,
  } = useSelector(updateSystemUiModuleComponent);

  useEffect(() => {
    if (linkType === "link_component" && updateStatus?.status === "success") {
      toast.success("Link to page component updated successfully");
      // system_api_module_list();
      dispatch(
        getSystemUiModuleListRequest({
          sort: [{ field: "name", order: "asc" }],
        })
      );

      close();
      dispatch(updateSystemUiModuleComponentClear());
    } else if (updateError?.message) {
      toast.error(updateError.message);
      dispatch(updateSystemUiModuleComponentClear());
    }
  }, [updateStatus, updateError, linkType, close, dispatch]);

  useEffect(() => {
    setLoading(updateLoading);
  }, [updateLoading, setLoading]);

  const systemApiModuleList = () => {
    dispatch(getSystemApiModuleListRequest({}));
  };

  useEffect(() => {
    systemApiModuleList();
  }, [dispatch]);

  const updatePageComponent = (data: { [key: string]: any }) => {
    let variables = { data, id: getId?.id || "" };
    dispatch(updateSystemUiModuleComponentRequest(variables));
  };

  const onFinish = (values: any) => {
    updatePageComponent({
      ...values,
      id: getId?.id,
      // name: any?.name,
    });
  };

  useEffect(() => {
    if (actionItem.apiModuleList.length > 0) {
      form.setFieldsValue({
        apiModuleIdList: actionItem?.apiModuleList?.map(
          (item: any) => item?.id
        ),
      }); 
    } else {
      form.resetFields();
    }
  }, [actionItem, form]);

  return (
    <div>
      <Form
        name="create page link"
        onFinish={onFinish}
        id="link_form"
        form={form}
      >
        <EndPoints apiList={apiList?.items || []} />
      </Form>
    </div>
  );
};

export default EndPointForm;
